import Loadable from '../../components/loadable';

const GradingEventsList = Loadable({
  loader: () => import('../../pages/gradings/grading_events'),
  type: 'block',
});

angular.module('gym').value('GradingEventsList', GradingEventsList);
